<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Cargo</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="accent" small to="/new-container">
            <v-icon left dark>mdi-plus</v-icon>New Cargo
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :headers="headers" :items="stores" :search="search">
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/container/${item.id}`" icon
                  ><v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    }
  },
  data: () => ({
    search: "",
    headers: [
      { text: "Cargo", value: "Name" },
      { text: "Description", value: "Description" },
      { text: "DocDate", value: "DocDate" },
      { text: "Action", value: "action" },
    ],
    stores: [],
  }),
  methods: {
    getStores() {
      const self = this;
      const ParentID = this.activeStore;
      this.$store
        .dispatch("get", `/stores?StrType=2&ParentID=${ParentID}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getStores();
  },
};
</script>